import { FilterData } from '@trinity/management-app-client';
import type { AxiosInstance } from 'axios';
import { z } from 'zod';

export interface AgentDataSource {
  id: number;
  name: string;
}

export interface AgentFilter {
  id: number;
  identifier: string;
  label: string;
  type: number;
  operators: string[];
  data: FilterData;
}

export interface GetAgentDataSourcesRequest {
  agentId: number;
}

export interface GetAgentDataSourcesResponse {
  dataSources: AgentDataSource[];
}

export interface GetAgentFiltersRequest {
  agentId: number;
}

export interface GetAgentFiltersResponse {
  filters: AgentFilter[];
}

export interface GetAgentResourcesRequest {
  agentIdentifier: string;
}

export interface GetAgentResourcesResponse {
  dataSources: AgentDataSource[];
  filters: AgentFilter[];
}

export interface SearchAgentHistoryRequest {
  agentIdentifier: string;
  filterId: number;
  query?: string;
};

const searchAgentHistoryResponseSchema = z.object({
  results: z.array(z.object({
    id: z.union([z.string(), z.number()]),
    name: z.string(),
  })),
});

//Can't use Zod to infer this type since we aren't using strict nulls
type SearchAgentHistoryResponse = {
  results: { id: string | number; name: string }[];
};

export class AgentResourcesClient {

  constructor(private authenticatedClient: AxiosInstance) { }

  getAgentResources = async (data: GetAgentResourcesRequest): Promise<GetAgentResourcesResponse> => {
    const response = await this.authenticatedClient.get<GetAgentResourcesResponse>(
      `/chat/agents/${data.agentIdentifier}/resources`,
    );
    return response.data;
  };

  searchAgentFilter = async (data: SearchAgentHistoryRequest): Promise<SearchAgentHistoryResponse> => {
    const response = await this.authenticatedClient.get(`/chat/agents/${data.agentIdentifier}/filter-search/${data.filterId}?query=${data.query ?? ''}`);
    return searchAgentHistoryResponseSchema.parse(response.data) as SearchAgentHistoryResponse;
  };
}